import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../App/redux/store';
import useAuth from '../auth/useAuth';
import { procedureEventsActions } from './actions';
import { getProcedureEventsState } from './reducer';

const useProcedureEvents = (pageName?: string) => {
  const { userIdIri } = useAuth({});
  const { adStudyProcedureEvents, dashboardProcedureEvents } = useAppSelector(
    getProcedureEventsState,
  );
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (userIdIri && pageName === 'dashboard') {
      dispatch(procedureEventsActions.fetchDashboardProcedureEvents.request());
    }
  }, [userIdIri]);

  return { adStudyProcedureEvents, dashboardProcedureEvents };
};

export default useProcedureEvents;
